import { render, staticRenderFns } from "./HelpBox.vue?vue&type=template&id=60f6b13a&scoped=true"
import script from "./HelpBox.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpBox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HelpBox.vue?vue&type=style&index=0&id=60f6b13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f6b13a",
  null
  
)

export default component.exports